import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ dataComponents: { pagination } }: ComposedTheme) => ({
  range: {
    fontFamily: pagination.rangeText.font.fontFamily,
    fontSize: pagination.rangeText.font.fontSize,
    fontWeight: pagination.rangeText.font.fontWeight,
    color: pagination.rangeText.color,
  },
  wrapper: {
    fontFamily: pagination.text.fontFamily,
    fontSize: pagination.text.fontSize,
    fontWeight: pagination.text.fontWeight,
    '& > div': {
      display: 'flex',
    },
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
  },
});

export default createUseStyles(styles);
